import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { THEME_COLORS } from "../../ThemeConfig";
import logo from "../../assets/images/header/logoimg.svg";
import facebookIcon from "../../assets/icons/facebook.svg";
import instagramIcon from "../../assets/icons/instagram.svg";
import youtubeIcon from "../../assets/icons/youtube.svg";
import linkedinIcon from "../../assets/icons/linkedin.svg";

const FACEBOOK_URL = "https://www.facebook.com/share/1EoJEn3sqn/";
const INSTAGRAM_URL = "https://www.instagram.com/mindmitrapsy?igsh=OXB4NHV6cTZzYXVl";
const YOUTUBE_URL = "https://youtube.com/@mymindmitra?si=k3ASkYM96jrnYHln";
const LINKEDIN_URL = "https://www.linkedin.com/company/my-mind-mitra";

export default function LandingFooter() {
  return (
    <FooterContainer>
      <FooterInner>
        <TopRow>
          <Brand>
            <FooterLogo to="/">
              <LogoImgWrap>
                <FooterLogoImg src={logo} alt="MindMitra" />
              </LogoImgWrap>
              <BrandTextWrap>
                <BrandName>
                  <BrandPartGreen>Mind</BrandPartGreen>
                  <BrandPartBlue>Mitra</BrandPartBlue>
                </BrandName>
                <Tagline>
                  Redefining mental healthcare through compassion and technology.
                </Tagline>
              </BrandTextWrap>
            </FooterLogo>
          </Brand>
          <Connect>
            <ConnectTitle>Connect</ConnectTitle>
            <ContactLink href="mailto:care@mymindmitra.com">
              care@mymindmitra.com
            </ContactLink>
            <SocialLinks>
              <SocialLink href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <SocialIcon src={facebookIcon} alt="Facebook" />
              </SocialLink>
              <SocialLink href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <SocialIcon src={instagramIcon} alt="Instagram" />
              </SocialLink>
              <SocialLink href={YOUTUBE_URL} target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                <SocialIcon src={youtubeIcon} alt="YouTube" />
              </SocialLink>
              <SocialLink href={LINKEDIN_URL} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <SocialIcon src={linkedinIcon} alt="LinkedIn" className="linkedin" />
              </SocialLink>
            </SocialLinks>
          </Connect>
          <Resources>
            <ResourcesTitle>Resources</ResourcesTitle>
            <ResourceLinks>
              <FooterLink to="/privacy-policy">Privacy Policy</FooterLink>
              <FooterLink to="/terms-and-conditions">Terms of Use</FooterLink>
              <FooterLink to="/refund-policy">Refund Policy</FooterLink>
              <FooterLink to="/faq">FAQ</FooterLink>
            </ResourceLinks>
          </Resources>
        </TopRow>
        <BottomRow>
          <Copyright>© 2026 My MindMitra. All Rights Reserved.</Copyright>
        </BottomRow>
      </FooterInner>
    </FooterContainer>
  );
}

const FooterContainer = styled.footer`
  background: ${THEME_COLORS.secondary};
  color: ${THEME_COLORS.white};
  padding: 48px 0 24px;
  margin-top: 60px;
  @media all and (max-width: 480px) {
    padding: 36px 0 20px;
    margin-top: 40px;
  }
`;
const FooterInner = styled.div`
  width: 80%;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  @media all and (max-width: 768px) {
    width: 90%;
  }
  @media all and (max-width: 480px) {
    width: 92%;
  }
`;
const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 32px;
  padding-bottom: 32px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  @media all and (max-width: 768px) {
    flex-direction: column;
    gap: 24px;
  }
`;
const Brand = styled.div`
  max-width: 320px;
`;
const FooterLogo = styled(Link)`
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  color: inherit;
  &:hover {
    opacity: 0.9;
  }
`;
const LogoImgWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  background: ${THEME_COLORS.white};
  border-radius: 10px;
  padding: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
`;
const FooterLogoImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
const BrandTextWrap = styled.div``;
const BrandName = styled.h3`
  display: inline-flex;
  font-family: "DM_sans_medium";
  font-size: 20px;
  margin-bottom: 4px;
`;
const BrandPartGreen = styled.span`
  color: ${THEME_COLORS.chips_green_on_container};
`;
const BrandPartBlue = styled.span`
  color: ${THEME_COLORS.chips_blue_on_container_2};
`;
const Tagline = styled.p`
  font-family: "DM_sans";
  font-size: 14px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.85);
`;
const Connect = styled.div``;
const ConnectTitle = styled.h4`
  font-family: "DM_sans_medium";
  font-size: 16px;
  margin-bottom: 8px;
  color: ${THEME_COLORS.white};
`;
const ContactLink = styled.a`
  font-family: "DM_sans";
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
  text-decoration: none;
  display: block;
  margin-bottom: 12px;
  &:hover {
    color: ${THEME_COLORS.chips_green_on_container};
  }
`;
const SocialLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
`;
const SocialLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  transition: background 0.2s;
  &:hover {
    background: ${THEME_COLORS.chips_green_on_container};
  }
`;
const SocialIcon = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
  &.linkedin {
    width: 16px;
    height: 16px;
  }
`;
const Resources = styled.div``;
const ResourcesTitle = styled.h4`
  font-family: "DM_sans_medium";
  font-size: 16px;
  margin-bottom: 8px;
  color: ${THEME_COLORS.white};
`;
const ResourceLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;
const FooterLink = styled(Link)`
  font-family: "DM_sans";
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
  text-decoration: none;
  &:hover {
    color: ${THEME_COLORS.chips_green_on_container};
  }
`;
const BottomRow = styled.div`
  padding-top: 24px;
  text-align: center;
`;
const Copyright = styled.p`
  font-family: "DM_sans";
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
`;
